import {AvatarProps, Sprite, usePlayers} from '@glark-newco/game-library';
import {Avatar, Box} from '@mantine/core';
import {useMemo} from 'react';
import {AvatarOptions, lookup} from '../hooks/useCreateAvatar';
import {usePlayerAvatar} from '../state/PlayerAvatarSlice';

function SupplyChainAvatar({playerId}: {playerId: string}) {
    const {players} = usePlayers();
    const avatar = usePlayerAvatar(playerId);

    const player = useMemo(() => {
        return players.find(p => p.playerId === playerId);
    }, [players, playerId]);

    const avatarOptions: Record<AvatarOptions, string | undefined> = useMemo(() => {
        return lookup(avatar);
    }, [avatar, playerId]);

    return (
        <Avatar name={player?.name}>
            <Box style={{position: 'relative', width: '100%', height: '100%'}}>
                {Object.keys(avatarOptions).map((key) => {
                    if (avatarOptions[key as AvatarOptions]) {
                        return (
                            <Box key={key} style={{position: 'absolute', top: '0%', width: '100%'}}>
                                <Sprite sprite={`${avatarOptions[key as AvatarOptions]}-T`} trimmed={true}/>
                            </Box>
                        );
                    }
                    return null;
                })}
            </Box>
        </Avatar>
    );
}

// A component-provider, not a true react-component, so it can't contain hooks.
export function SupplyChainAvatarProvider({playerId}: AvatarProps) {
    return <SupplyChainAvatar playerId={playerId} />;
}
